module.exports = __webpack_public_path__ + "img/Logo-horizontal-branco.067e861c.png";